/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const MarketplaceDTOMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the MarketplaceDTO interface.
 */
export function instanceOfMarketplaceDTO(value) {
    return true;
}
export function MarketplaceDTOFromJSON(json) {
    return MarketplaceDTOFromJSONTyped(json, false);
}
export function MarketplaceDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'marketplaceId': json['marketplaceId'] == null ? undefined : json['marketplaceId'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}
export function MarketplaceDTOToJSON(json) {
    return MarketplaceDTOToJSONTyped(json, false);
}
export function MarketplaceDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'marketplace': value['marketplace'],
        'marketplaceId': value['marketplaceId'],
        'country': value['country'],
    };
}
